import { createMuiTheme } from '@material-ui/core/styles';
import {
  // light,
  grey,
  dark,
  // disabledColor,
  // backgroundColor,
  primaryColor,
  // primaryColorLight,
  secondaryColor,
  // tercaryColor,
  // tercaryColorLight,
  // bodyColor,
  // titleColor,
} from 'helpers/colors';
const disabledColor = '#888';
export const orangeTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#fff',
      main: '#000',
    },
    secondary: {
      contrastText: '#fff',
      main: secondaryColor,
      // main: '#ff0000',
      // dark: '#ff0000'
    },
    text: {
      primary: '#000',
      light: '#999',
      disabled: disabledColor,
    },
    type: 'dark',
    background: {
      default: '#fff',
    },
  },
  // background: {
  //   default: '#ff0000',
  //   paper: '#ff0000'
  // },
  typography: {
    body1: {
      fontSize: '1rem',
      // color: secondaryColor
      color: 'inherit',
    },
  },
  overrides: {
    MuiAlert: {
      maxWidth: 800,
      margin: '0 auto',
      standardSuccess: {
        backgroundColor: 'rgb(183, 223, 185)',
        color: dark,
        textAlign: 'left',
        justifyContent: 'center',
        fontSize: '1.2rem',
      },
      standardError: {
        backgroundColor: '#fff',
        color: '#f44336',
        textAlign: 'left',
        justifyContent: 'center',
        fontSize: '1.2rem',
      },
    },
    MuiInputBase: {
      input: {
        backgroundColor: '#fff' + ' !important',
        color: '#000',
        '&$disabled': {
          color: disabledColor,
        },
      },
    },
    MuiFormHelperText: {
      contained: {
        color: '#000',
      },
    },
    MuiInputLabel: {
      root: {
        color: '#000',
      },
      outlined: {
        fontWeight: 'bold',
        color: '#000',
      },
    },
    MuiTypography: {
      caption: {
        color: '#fff',
      },
    },
    MuiButton: {
      containedSizeLarge: {
        padding: '8px 50px',
        fontSize: '22px',
      },
    },
    // Input: {
    //   root: {
    //     backgroundColor: 'tansparent !important'
    //   }
    // },
    // MuiOutlinedInput: {
    //   root: {
    //     backgroundColor: '#fff !important'
    //   }
    // },
    // MuiInputLabel: {
    //   outlined: {
    //     fontWeight: 'bold',
    //   }
    // },
    // MuiInputBase: {
    //   input: {
    //     backgroundColor: '#fff' + ' !important',
    //     color: dark,
    //     '&$disabled': {
    //       color: disabledColor
    //     }
    //   }
    // },
    // MuiFormHelperText: {
    //   contained: {
    //     color: dark
    //   },
    //   root: {
    //     '&$error': {
    //       color: 'red',
    //       backgroundColor: '#fff',
    //       padding: '5px 10px',
    //     }
    //   }
    // },
  },
});



// WEBPACK FOOTER //
// ./src/components/ThemeAlt.jsx